import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const DOCS = {
  privacidad: {
    title: "Política de Privacidad",
    content: `
# Política de Privacidad

**ARIA Wallet by AriaPC**

Última actualización: 7 de junio de 2026

## 1. Responsable del tratamiento

- **Nombre:** Calin Adrian Olenici
- **NIF:** X9244972F
- **Dirección:** Carrer Venus 22, Local 2, Lleida, España
- **Email de contacto:** aariapc@gmail.com
- **Web:** dondeestatudinero.es

## 2. Datos que recopilamos

Recopilamos los siguientes datos personales:

- **Datos de registro:** nombre, dirección de correo electrónico y contraseña cifrada
- **Datos financieros:** ingresos, gastos, cuentas y categorías que el usuario introduce voluntariamente
- **Datos de pago:** gestionados por Stripe (no almacenamos datos de tarjeta)
- **Datos técnicos:** dirección IP, tipo de navegador y dispositivo, para el correcto funcionamiento del servicio

## 3. Finalidad del tratamiento

Utilizamos tus datos para:

- Prestarte el servicio de gestión financiera personal
- Gestionar tu suscripción y pagos
- Enviarte comunicaciones relacionadas con el servicio
- Mejorar la aplicación y detectar errores

## 4. Base legal

El tratamiento de tus datos se basa en:

- **Ejecución del contrato:** para prestarte el servicio contratado
- **Consentimiento:** para el envío de comunicaciones comerciales
- **Obligación legal:** para el cumplimiento de obligaciones fiscales y contables

## 5. Conservación de datos

Conservamos tus datos mientras mantengas una cuenta activa. Si cancelas tu cuenta, eliminaremos tus datos en un plazo máximo de 30 días, salvo obligación legal de conservarlos.

## 6. Destinatarios

Tus datos pueden ser compartidos con:

- **Firebase (Google LLC):** almacenamiento de datos y autenticación
- **Stripe Inc.:** procesamiento de pagos
- **Autoridades competentes:** cuando sea requerido por ley

## 7. Transferencias internacionales

Firebase y Stripe pueden transferir datos fuera del Espacio Económico Europeo. Ambas empresas cuentan con las garantías adecuadas según el RGPD.

## 8. Tus derechos

Tienes derecho a:

- **Acceso:** conocer qué datos tenemos sobre ti
- **Rectificación:** corregir datos inexactos
- **Supresión:** solicitar la eliminación de tus datos
- **Portabilidad:** recibir tus datos en formato legible
- **Oposición:** oponerte al tratamiento de tus datos
- **Limitación:** solicitar la limitación del tratamiento

Para ejercer estos derechos, contacta en: aariapc@gmail.com

También puedes presentar una reclamación ante la **Agencia Española de Protección de Datos (AEPD)** en www.aepd.es

## 9. Seguridad

Aplicamos medidas técnicas y organizativas para proteger tus datos, incluyendo cifrado en tránsito (HTTPS) y en reposo.

## 10. Cambios en esta política

Notificaremos cualquier cambio relevante por email o mediante aviso en la aplicación.
    `
  },
  terminos: {
    title: "Términos y Condiciones",
    content: `
# Términos y Condiciones

**ARIA Wallet by AriaPC**

Última actualización: 13 de agosto de 2026

## 1. Información del prestador

- **Nombre:** Calin Adrian Olenici
- **NIF:** X9244972F
- **Dirección:** Carrer Venus 22, Local 2, Lleida, España
- **Email:** aariapc@gmail.com
- **Web:** dondeestatudinero.es

## 2. Objeto del servicio

**ARIA Wallet** es una aplicación web de gestión financiera personal que permite registrar ingresos, gastos, cuentas y obtener informes financieros.

## 3. Registro y cuenta de usuario

Para usar el servicio debes registrarte con un email y contraseña válidos. Eres responsable de mantener la confidencialidad de tus credenciales. Debes tener al menos 18 años para registrarte.

## 4. Planes y precios

### Plan Gratuito
- 30 entradas por mes
- Historial de 3 meses
- 1 gráfico básico

### Plan Pro — 1,99€/mes
- Entradas ilimitadas
- Historial completo
- 4 gráficos avanzados
- Exportar CSV
- Cuentas ilimitadas
- Soporte por email

## 5. Pagos y facturación

- Los pagos se procesan mediante **Stripe**
- La suscripción se renueva automáticamente cada mes
- Puedes cancelar en cualquier momento desde tu panel de Stripe
- No se realizan reembolsos por períodos parciales ya facturados
- Los precios incluyen IVA cuando corresponda

## 6. Cancelación

Puedes cancelar tu suscripción en cualquier momento. Seguirás teniendo acceso al Plan Pro hasta el final del período pagado.

## 7. Propiedad intelectual

Todos los derechos sobre la aplicación, diseño y contenido son propiedad de Calin Adrian Olenici. Queda prohibida su reproducción sin autorización expresa.

## 8. Limitación de responsabilidad

La aplicación es una herramienta de apoyo a la gestión financiera personal. No somos responsables de decisiones financieras tomadas basándose en los datos introducidos por el usuario.

## 9. Disponibilidad del servicio

Nos esforzamos por mantener el servicio disponible 24/7, pero no garantizamos la disponibilidad continua.

## 10. Modificaciones

Nos reservamos el derecho de modificar estos términos. Notificaremos los cambios relevantes con al menos 15 días de antelación por email.

## 11. Ley aplicable

Estos términos se rigen por la legislación española. Para cualquier disputa, las partes se someten a los juzgados de Lleida.

## 12. Contacto

Para cualquier consulta: aariapc@gmail.com
    `
  },
  aviso: {
    title: "Aviso Legal",
    content: `
# Aviso Legal

**ARIA Wallet by AriaPC**

## Datos del titular

En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa:

- **Titular:** Calin Adrian Olenici
- **NIF:** X9244972F
- **Dirección:** Carrer Venus 22, Local 2, Lleida, España
- **Email:** aariapc@gmail.com
- **Web:** dondeestatudinero.es

## Propiedad intelectual e industrial

Todos los contenidos de esta aplicación web — incluyendo textos, imágenes, diseño, código fuente y logotipos — son propiedad de Calin Adrian Olenici o cuenta con las licencias correspondientes.

Queda expresamente prohibida la reproducción, distribución, comunicación pública o transformación de cualquier elemento sin autorización expresa y por escrito del titular.

## Exclusión de responsabilidad

El titular no se hace responsable de:

- Errores u omisiones en los contenidos
- Daños derivados del uso de la aplicación
- Interrupciones del servicio por causas ajenas al titular
- Decisiones financieras tomadas por el usuario basándose en los datos de la aplicación

## Legislación aplicable

Este aviso legal se rige por la legislación española vigente.
    `
  },
  cookies: {
    title: "Política de Cookies",
    content: `
# Política de Cookies

**ARIA Wallet by AriaPC**

Última actualización: 7 de junio de 2026

## ¿Qué son las cookies?

Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas una web. Sirven para recordar tus preferencias y mejorar tu experiencia.

## Cookies que utilizamos

### Cookies técnicas (necesarias)

Son imprescindibles para el funcionamiento de la aplicación:

- **firebase:authUser** — Firebase (Google) — Mantener la sesión iniciada — Duración: Sesión
- **__session** — Firebase — Autenticación segura — Duración: Sesión

### Cookies de terceros

Utilizamos los siguientes servicios que pueden establecer sus propias cookies:

- **Firebase (Google LLC):** autenticación y base de datos
- **Stripe Inc.:** procesamiento de pagos

## ¿Cómo desactivar las cookies?

Puedes configurar tu navegador para rechazar cookies:

- **Chrome:** Configuración → Privacidad y seguridad → Cookies
- **Firefox:** Opciones → Privacidad y seguridad
- **Safari:** Preferencias → Privacidad
- **Edge:** Configuración → Privacidad

Ten en cuenta que desactivar las cookies técnicas puede impedir el funcionamiento correcto de la aplicación.

## Contacto

Para cualquier consulta sobre cookies: aariapc@gmail.com
    `
  }
};

function renderMarkdown(text) {
  const lines = text.trim().split('\n');
  return lines.map((line, i) => {
    if (line.startsWith('# ')) return <h1 key={i} style={{fontSize:22,fontWeight:800,color:'var(--gray-900)',marginBottom:12,marginTop:24}}>{line.slice(2)}</h1>;
    if (line.startsWith('## ')) return <h2 key={i} style={{fontSize:17,fontWeight:700,color:'var(--gray-800)',marginBottom:8,marginTop:20,paddingBottom:4,borderBottom:'1px solid var(--border)'}}>{line.slice(3)}</h2>;
    if (line.startsWith('### ')) return <h3 key={i} style={{fontSize:15,fontWeight:600,color:'var(--gray-700)',marginBottom:6,marginTop:14}}>{line.slice(4)}</h3>;
    if (line.startsWith('- **')) {
      const parts = line.slice(2).split('**');
      return <li key={i} style={{marginBottom:4,color:'var(--gray-700)',fontSize:14}}><strong>{parts[1]}</strong>{parts[2]}</li>;
    }
    if (line.startsWith('- ')) return <li key={i} style={{marginBottom:4,color:'var(--gray-700)',fontSize:14}}>{line.slice(2)}</li>;
    if (line.startsWith('**') && line.endsWith('**')) return <p key={i} style={{fontWeight:600,color:'var(--gray-800)',fontSize:14,marginBottom:6}}>{line.slice(2,-2)}</p>;
    if (line.trim() === '') return <br key={i}/>;
    return <p key={i} style={{color:'var(--gray-700)',fontSize:14,marginBottom:6,lineHeight:1.6}}>{line}</p>;
  });
}

export default function Legal() {
  const params = new URLSearchParams(window.location.search);
  const initialTab = params.get("tab") || "privacidad";
  const [tab, setTab] = useState(initialTab);
  const navigate = useNavigate();

  return (
    <div style={{minHeight:"100vh",background:"var(--bg)",padding:"24px 16px"}}>
      <div style={{maxWidth:760,margin:"0 auto"}}>

        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
          <button onClick={()=>navigate(-1)} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:"var(--gray-500)"}}>←</button>
          <img src="/icon-512.png" alt="" style={{width:28,height:28,borderRadius:8}}/>
          <div>
            <h1 style={{fontSize:20,fontWeight:800,color:"var(--gray-900)"}}>ARIA Wallet by AriaPC</h1>
            <p style={{fontSize:13,color:"var(--gray-500)"}}>Información legal</p>
          </div>
        </div>

        <div style={{display:"flex",gap:8,marginBottom:24,flexWrap:"wrap"}}>
          {Object.entries(DOCS).map(([key, doc]) => (
            <button key={key} onClick={() => setTab(key)}
              style={{padding:"8px 16px",borderRadius:20,border:`2px solid ${tab===key?"var(--blue)":"var(--border)"}`,
                      background:tab===key?"var(--blue-l)":"white",color:tab===key?"var(--blue)":"var(--gray-600)",
                      fontSize:13,fontWeight:500,cursor:"pointer"}}>
              {doc.title}
            </button>
          ))}
        </div>

        <div style={{background:"white",borderRadius:12,border:"1px solid var(--border)",padding:"28px 32px",boxShadow:"0 1px 3px rgba(0,0,0,.06)"}}>
          {renderMarkdown(DOCS[tab].content)}
        </div>

        <p style={{textAlign:"center",fontSize:12,color:"var(--gray-400)",marginTop:20}}>
          © 2026 Calin Adrian Olenici · aariapc@gmail.com
        </p>
      </div>
    </div>
  );
}
